var React = require('react');

function Producthunt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M240,120 C240,186.274 186.274,240 120,240 C53.726,240 0,186.274 0,120 C0,53.726 53.726,0 120,0 C186.274,0 240,53.726 240,120","key":0}),React.createElement("path",{"fill":"#FFF","d":"M136,120 L136,120.001 L102,120.001 L102,84.001 L136,84.001 L136,84 C145.941,84 154,92.059 154,102 C154,111.941 145.941,120 136,120 M136,60 L136,60 L78,60 L78,180 L102,180 L102,144.001 L136,144.001 L136,144 C159.196,144 178,125.196 178,102 C178,78.804 159.196,60 136,60","key":1})]);
}

Producthunt.defaultProps = {"viewBox":"0 0 240 240"};

module.exports = Producthunt;

Producthunt.default = Producthunt;
